module.exports = __webpack_public_path__ + "img/knet.96e97b80.png";